import API from "@/package/config/axios";

export const apiGetUser = () => {
  return API.get("api/me");
};
